import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  Select,
  Input,
  Button,
  Upload,
  Col,
  Row,
  Typography,
  Progress,
} from "antd";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { MdCancel } from "react-icons/md";
import PDF from "../../../assets/images/pdf.svg";
import Excel from "../../../assets/images/excel.svg";
import Document from "../../../assets/images/document.svg";
import Ppt from "../../../assets/images/ppt.svg";
import Image from "../../../assets/images/image.svg";
import File from "../../../assets/images/file.svg";
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import FileCard from "../../../components/FileCard/index";
import algoliasearch from "algoliasearch/lite";
import Title from "antd/lib/skeleton/Title";

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_CLIENT,
  process.env.REACT_APP_ALGOLIA_KEY
);

const { Link } = Typography;
const { Option } = Select;

//const client = algoliasearch('YourApplicationID', 'YourSearchOnlyAPIKey');

export default function FieldRenderer({
  fields,
  form,
  files,
  formData,
  loading,
  categoryId,
  allCategoryData,
  sizeUnits,
  setSizeUnits,
  showExclusiveDetails,
}) {
  const [fileList, setFileList] = useState([]);
  const [progressData, setProgressData] = useState({});
  const [error, setError] = useState(null);
  const [comment, setComment] = useState(null);
  const [progress, setProgress] = useState(0);
  const [facetsResult, setFacetsResult] = useState(null);

  const children = [];
  for (let i = 10; i < 36; i++) {
    children.push(
      <Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>
    );
  }

  useEffect(() => {
    const org = localStorage.getItem("org");
    const orgDetails = org && JSON.parse(org);
    let selectedCategory;
    if (allCategoryData && categoryId) {
      allCategoryData.filter((a) => {
        if (a.secondary_category_id.id === categoryId) {
          selectedCategory = a.secondary_category_id.name;
          return a.secondary_category_id.id === categoryId;
        }
      });
    }
    const index = searchClient.initIndex("products");
    const filterSearch = `secondary_category.name:'${selectedCategory}' AND manufacturer:${orgDetails?.id}`;

    //console.log("filterSearch", filterSearch);

    index
      .search(" ", {
        facets: ["transformedAttributes.*"],
        filters: filterSearch,
      })
      .then((res) => {
        const results = res.facets;
        let facetInfo = [];

        for (let key in results) {
          const facetName = key.split(".")[1];

          facetInfo.push({ [facetName]: Object.keys(results[key]) });
        }

        setFacetsResult(Object.assign({}, ...facetInfo));
      });
  }, [categoryId,allCategoryData]);

  useEffect(() => {
    if (files && files.length > 0) {
      const filelist = files.map(
        (file) => file?.attribute_values_id?.composite || file?.composite
      );
      const commentData = files.map(
        (file) => file?.attribute_values_id?.values || file?.values
      );
      setFileList(filelist?.[0]);
      setComment(commentData?.[0]);

      // setFilesData(files)
    }
  }, [files]);

  useEffect(() => {
    if (fields && fields.length > 0) {
      const fileFields = fields.filter(
        (field) =>
          field?.attributes_id?.dtype === "file" || field?.dtype === "file"
      );
      if (fileFields && fileFields.length > 0) {
        fileFields.forEach((field) =>
          form.setFieldsValue({
            [`${field?.attributes_id?.name || field?.name}:${
              field?.attributes_id?.id || field?.id
            }`]: {
              comment: comment,
              fileList: fileList,
            },
          })
        );
      }
    }
  }, [fields, fileList, comment, form]);

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      // onUploadProgress: event => {
      //   const percent = Math.floor((event.loaded / event.total) * 100);
      //   console.log("percent",percent)
      // }
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgressData((prevState) => {
          return { percent };
        });
        if (percent === 100) {
          setTimeout(
            () =>
              setProgressData((prevState) => {
                return { ...prevState, percent };
              }),
            1000
          );
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("image", file);

    axios
      .post(process.env.REACT_APP_ARTIFACTS, fmData, config)
      .then((response) => {
        if (response.status === 200) {
          onSuccess("Ok");
          setFileList((result) => [...result, response?.data?.data]);
        }
      })
      .catch((err) => {
        setError("Something went wrong");
        onError({ err });
      });
  };

  const renderLabel = (label, dtype = "") => {
    return (
      <div>
        <span>{showExclusiveDetails ? "Buyer Name" : label}</span>
        <span style={{ color: "grey" }}>
          {dtype === "size" && <span>{" (LxBxH) "}</span>}
          {showExclusiveDetails ? "" : " (Optional)"}
        </span>
      </div>
    );
  };

  const getConvertedValue = (value, unitTo) => {
    value = parseFloat(value);
    const conversionMap = {
      inches: 0.393701,
      cm: 2.54,
      cms: 2.54,
    };

    return value * conversionMap[unitTo];
  };

  const handleSizeUnitChange = (name, e) => {
    const values = form.getFieldsValue();
    // const key = name.split(":unit")[0] || "";
    if (!sizeUnits[name]) {
      setSizeUnits((state) => {
        return {
          ...state,
          [name]: e,
        };
      });
      return;
    } else {
      const oldUnit = sizeUnits[name];
      if (oldUnit !== e) {
        setSizeUnits((state) => {
          return {
            ...state,
            [name]: e,
          };
        });
        let width = values[`${name}:width`];
        let height = values[`${name}:height`];
        let length = values[`${name}:length`];
        if (height) {
          form.setFieldsValue({
            [`${name}:height`]: getConvertedValue(height, e)
              .toFixed(1)
              .toString(),
          });
        }
        if (width) {
          form.setFieldsValue({
            [`${name}:width`]: getConvertedValue(width, e)
              .toFixed(1)
              .toString(),
          });
        }
        if (length) {
          form.setFieldsValue({
            [`${name}:length`]: getConvertedValue(length, e)
              .toFixed(1)
              .toString(),
          });
        }
      }
    }
  };

  useEffect(() => {
    let totalProgress = 0;
    let totalCount = 0;
    for (let imageFileId in progressData) {
      let p = progressData[imageFileId];
      if (p > 0) {
        totalProgress = totalProgress + p;
        totalCount = totalCount + 1;
      }
    }
    const reultantProgress =
      totalCount === 0 ? 0 : Math.floor(totalProgress / totalCount);
    if (reultantProgress === 100) setTimeout(() => setProgressData({}), 1000);
    setProgress(reultantProgress);
  }, [progressData]);

  const handleDelete = (file) => {
    setFileList(fileList.filter((f) => f.id !== file.id));
  };

  const fileType = (name) => {
    function getExtension(filename) {
      var parts = filename.split(".");
      return parts[parts.length - 1];
    }
    var ext = getExtension(name);

    const fileObj = {
      pdf: "pdf",
      png: "image",
      jpg: "image",
      jpeg: "image",
      doc: "document",
      docx: "document",
      xls: "excel",
      xlsx: "excel",
      ppt: "ppt",
      pptx: "ppt",
      txt: "document",
      csv: "excel",
      zip: "file",
      rar: "file",
    };

    const iconObj = {
      image: <img src={Image} alt="alt" width={48} />,
      pdf: <img src={PDF} alt="alt" width={48} />,
      document: <img src={File} alt="alt" width={48} />,
      excel: <img src={Excel} alt="alt" width={48} />,
      file: <img src={Document} alt="alt" width={48} />,
      ppt: <img src={Ppt} alt="alt" width={48} />,
    };
    return iconObj[fileObj[ext]] || <img src={File} alt="alt" width={48} />;
  };
  const renderLoadingHeader = () => {
    if (progress > 0) {
      return (
        <Row style={{ margin: "1em" }}>
          <Progress
            style={{
              marginTop: "0.5rem",
            }}
            percent={progress}
            width={"2vh"}
          />
        </Row>
      );
    }
    return <></>;
  };

  const fieldRender = (dtype, name, defaults, value, id) => {
    const fieldsObject = {
      csv: (
        <Form.Item
          label={renderLabel(name)}
          name={`${name}:${id}`}
          value={value}
          rules={[
            {
              required: showExclusiveDetails ? true : false,
              message: "Please Select or Enter atleast one Buyer Name",
            },
          ]}
        >
          <Select
            mode="tags"
            placeholder={
              showExclusiveDetails
                ? "Select or Enter Buyer Name"
                : `Select or Enter ${name}`
            }
            size="large"
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.FIELD_RENDERER_SELECT_INPUT_FIELDS
              );
            }}

            //options={DrpValue?DrpValue:[]}
          >
            {facetsResult && facetsResult?.[showExclusiveDetails?"ExclusiveBuyerDetails":name]?.length > 0
              ? facetsResult?.[showExclusiveDetails?"ExclusiveBuyerDetails":name]?.map(
                  (value, index) =>
                    value && (
                      <Option key={index} value={value}>
                        {value}
                      </Option>
                    )
                )
              : null}
          </Select>
        </Form.Item>
      ),
      text: (
        <Form.Item name={`${name}:${id}`} label={renderLabel(name)}>
          <Input
            size="large"
            placeholder={`Enter ${name}`}
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.FIELD_RENDERER_INPUT_NAME
              );
            }}
          />
        </Form.Item>
      ),
      price: (
        <Can
          I={PERMISSIONS.global_permissions.slug}
          a={PERMISSIONS.global_permissions.permissionType}
          passThrough
        >
          {(allowed) => (
            <Form.Item
              name={`${name}:${id}`}
              label={renderLabel(name)}
              hidden={!allowed}
            >
              <Input
                size="large"
                type="number"
                placeholder={`Enter Price`}
                onWheel={(e) => e.currentTarget.blur()}
                addonBefore={
                  <Form.Item name={`${name}:${id}:currency`} noStyle>
                    <Select
                      style={{
                        width: 150,
                      }}
                      size="large"
                      placeholder={`Select Currency`}
                      onClick={() => {
                        gaEvent(
                          GA.EVENT.CLICK,
                          GA.CATEGORY.ADD_PRODUCT,
                          GA.DESCRIPTION.FIELD_RENDERER_SELECT_PRICE_CURRENCY
                        );
                      }}
                    >
                      {defaults?.currency?.length > 0
                        ? defaults?.currency?.map((curr) => (
                            <Option value={curr}>{curr}</Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item>
                }
                addonAfter={
                  <Form.Item name={`${name}:${id}:unit`} noStyle>
                    <Select
                      style={{
                        width: 150,
                      }}
                      size="large"
                      placeholder={`Select Unit`}
                      onClick={() => {
                        gaEvent(
                          GA.EVENT.CLICK,
                          GA.CATEGORY.ADD_PRODUCT,
                          GA.DESCRIPTION.FIELD_RENDERER_SELECT_PRICE_UNITS
                        );
                      }}
                    >
                      {defaults?.unit?.length > 0
                        ? defaults?.unit?.map((curr) => (
                            <Option value={curr}>{curr}</Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item>
                }
                style={{
                  width: "100%",
                }}
                onClick={() => {
                  gaEvent(
                    GA.EVENT.CLICK,
                    GA.CATEGORY.ADD_PRODUCT,
                    GA.DESCRIPTION.FIELD_RENDERER_INPUT_PRICE
                  );
                }}
              />
            </Form.Item>
          )}
        </Can>
      ),
      size: (
        <Form.Item
          name={`${name}:${id}--size`}
          label={renderLabel(name, "size")}
        >
          <Row>
            <Col span="6">
              <Form.Item name={`${name}:${id}:length`}>
                <Input
                  size="large"
                  type="number"
                  className="size_attribute_input"
                  style={{ borderRadius: "4px 0 0 4px" }}
                  placeholder={`Length`}
                  onWheel={(e) => e.currentTarget.blur()}
                  onClick={() => {
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.ADD_PRODUCT,
                      GA.DESCRIPTION.FIELD_RENDERER_INPUT_PRICE
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col span="6">
              <Form.Item name={`${name}:${id}:width`}>
                <Input
                  size="large"
                  className="size_attribute_input"
                  style={{ borderRadius: "0" }}
                  type="number"
                  placeholder={`Breadth`}
                  onWheel={(e) => e.currentTarget.blur()}
                  // style={{
                  //   width: "25%",
                  // }}
                  onClick={() => {
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.ADD_PRODUCT,
                      GA.DESCRIPTION.FIELD_RENDERER_INPUT_PRICE
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col span="12">
              <Form.Item name={`${name}:${id}:height`}>
                <Input
                  size="large"
                  type="number"
                  className="size_height"
                  placeholder={`Height`}
                  onWheel={(e) => e.currentTarget.blur()}
                  addonAfter={
                    <Form.Item name={`${name}:${id}:unit`} noStyle>
                      <Select
                        // onChange={(e) =>
                        //   handleSizeUnitChange(`${name}:${id}:unit`, e)
                        // }
                        onSelect={(e, x) =>
                          handleSizeUnitChange(`${name}:${id}`, e)
                        }
                        style={{
                          width: 150,
                          borderRadius: "0 4px 4px 0",
                        }}
                        size="large"
                        placeholder={`Select Unit`}
                      >
                        {defaults?.unit?.length > 0
                          ? defaults?.unit?.map((curr) => (
                              <Option value={curr}>{curr}</Option>
                            ))
                          : null}
                      </Select>
                    </Form.Item>
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
      ),
      select: (
        <Form.Item label={renderLabel(name)} name={`${name}:${id}`}>
          <Select
            size="large"
            placeholder={`Select ${name}`}
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.FIELD_RENDERER_SELECT_FIELDS_ONLY
              );
            }}
          >
            {defaults && defaults?.select?.length > 0
              ? defaults?.select?.map((value, index) => (
                  <Option key={index} value={value}>
                    {value}{" "}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
      ),
      textarea: (
        <Form.Item name={`${name}:${id}`} label={renderLabel(name)}>
          <Input.TextArea
            size="large"
            placeholder={`Enter ${name}`}
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.FIELD_RENDERER_TEXTAREA_DESCRIPTION
              );
            }}
          />
        </Form.Item>
      ),
      file: (
        <Form.Item name={`${name}:${id}`} label={renderLabel(name)}>
          {/* <Input.TextArea value={comment} onChange={(e) => setComment(e.target.value)} /> */}

          {renderLoadingHeader()}
          {fileList.length > 0 && (
            <Row>
              {fileList.map((file, index) => (
                <Col span={12}>
                  <FileCard
                    fileName={file?.name}
                    fileIcon={fileType(file?.name)}
                    actionIcon={
                      <MdCancel
                        fontSize="24px"
                        color="#B4B7B6"
                        cursor="pointer"
                        onClick={() => handleDelete(file)}
                      />
                    }
                    secondaryAction={
                      file?.name.includes("png") ||
                      file?.name.includes("PNG") ||
                      file?.name.includes("JPG") ||
                      file?.name.includes("JPEG") ||
                      file?.name.includes("pdf") ||
                      file?.name.includes("jpg") ||
                      file?.name.includes("jpeg") ||
                      file?.name.includes("heic") ||
                      file?.name.includes("webp") ? (
                        <Link
                          href={`${process.env.REACT_APP_DIRECTUS}assets/${file.id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Click here to view
                        </Link>
                      ) : null
                    }
                  />
                </Col>
              ))}
            </Row>
            // <Col key={index} xl={5} xxl={5} md={7} sm={11} xs={22} className="sz-filelist" style={{marginTop:'0.75em'}}>
            //    <span>
            //       <a
            //         href={`${process.env.REACT_APP_DIRECTUS}assets/${file.id}`}
            //         target="_blank"
            //         rel="noreferrer"
            //       >
            //         {/* <MdRemoveRedEye className="sz-filelist-icon" /> */}
            //         {fileType(file.name)}
            //       </a>
            //     </span>
            //   <span className="truncate">{file.name}</span>
            //   <span style={{ float: "right" }}>
            //     <MdCancel
            //       className="sz-filelist-icon-delete"
            //       onClick={() => handleDelete(file)}
            //     />
            //   </span>
            // </Col>
          )}
          <Row style={{ marginTop: "1em" }}>
            <Upload
              multiple
              customRequest={uploadImage}
              className="upload-list-inline"
              showUploadList={false}
              fileList={fileList}
            >
              <Button icon={<UploadOutlined />}>Upload files</Button>
            </Upload>
          </Row>
        </Form.Item>
      ),
    };
    return fieldsObject[dtype] || <h1>Item not found</h1>;
  };

  return (
    <>
      {fields &&
        !loading &&
        fields.map((field) =>
          fieldRender(
            field?.attributes_id?.dtype || field?.dtype,
            field?.attributes_id?.name || field?.name,
            field?.attributes_id?.default || field?.default,
            null,
            field?.attributes_id?.id || field?.id
          )
        )}
    </>
  );
}
